import isArray from 'lodash/isArray'

export const formatGroups = (groupObject) => {
  if (isArray(groupObject)) return groupObject
  else return [groupObject]
}